<template>
  <div class="max-w-lg w-full mx-auto">
    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
      <div class="mt-16 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6">
        <div class="text-center">
          <h1
            class="
              text-2xl tracking-tight font-extrabold text-gray-900 sm:text-3xl
            "
          >
            <span>That's it {{ name }},</span>
            <span class="text-mygrad">we're all set!</span>
          </h1>
          <p
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            Thank you for submitting your timings, you will receive an email
            shortly with a link to your GraduationClip.
          </p>
          <p
            class="
              mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
            "
          >
            If you want to adjust your GraduationClip, simply go back and submit
            new timings.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Submitted",
  props: { name: String },
};
</script>